import { all, call } from 'redux-saga/effects';
import { default as clientsSagas } from './clients/clients.sagas';
import { default as clientSagas } from './clients/client.sagas';
import { default as userSagas } from './users/user.sagas';
import { default as usersSagas } from './users/users.sagas';
import { default as profileSagas } from './profiles/profile.sagas';
import { default as criteriaSagas } from './criteria/criteria.sagas';
import { default as applicationsSagas } from './applications/applications.sagas';
import { default as applicationSagas } from './applications/application.sagas';
import { default as appOperationsSagas } from './applications/appOperations.sagas';
import { default as rolesSagas } from './roles/roles.sagas';
import { default as roleSagas } from './roles/role.sagas';
import { default as rolePolicySagas } from './roles/rolePolicy.sagas';
import { default as rolePoliciesSagas } from './roles/rolePolicies.sagas';
import { default as resourcesSagas } from './resources/resources.sagas';
import { default as resourceSagas } from './resources/resource.sagas';
import { default as operationsSagas } from './operations/operations.sagas';
import { default as operationSagas } from './operations/operation.sagas';
import { default as contextsSagas } from './contexts/contexts.sagas';
import { default as apiResourcesSagas } from './apiResources/apiResources.sagas';

export default function* root() {
	yield all([
		call(clientsSagas),
		call(clientSagas),
		call(userSagas),
		call(usersSagas),
		call(profileSagas),
		call(criteriaSagas),
		call(applicationsSagas),
		call(applicationSagas),
		call(appOperationsSagas),
		call(rolesSagas),
		call(rolePolicySagas),
		call(roleSagas),
		call(resourcesSagas),
		call(resourceSagas),
		call(operationsSagas),
		call(operationSagas),
		call(contextsSagas),
		call(rolePoliciesSagas),
		call(apiResourcesSagas)
	]);
}
